import '../../app.constants'
import '../../services/errors';
import '../../services/globals';
import '../../services/place';
import '../../services/user';
import '../../services/capacity';
import '../../services/organization-messages';
import '../modals/capacity/entry-info';
import '../modals/capacity/chat';
import '../modals/capacity/add-physical-entries';
import '../../components/input-spinner';

import angular from 'angular';
import { get, find, filter, sortBy, head, set } from 'lodash';

const module = angular.module('whyline.controllers.capacity-control', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.place',
  'whyline.services.capacity',
  'whyline.services.organization-messages',
  'whyline.modals.entry-info',
  'whyline.modals.add-physical-entries',
  'whyline.components.inputSpinner',
  'whyline.modals.capacity-chat',,
]);

const CapacityControlController = ($rootScope, $scope, $timeout, PlaceService, CapacityService, $translate, dialog, NotificationService, OrganizationMessagesService, $uibModal) => {
  /*@ngInject*/

  $scope.total = 0;
  $scope.capacity = 0;
  $scope.totalPhysical = 0;
  $scope.qr = null;
  $scope.agendaLink = '';
  $scope.entries = [];
  $scope.selectedEntry = {};
  $scope.totalPeopleWaiting = 0;
  $scope.sendMessages = false;
  $scope.requiresConfirmation = false;
  $scope.supportDelay = false;
  $scope.bulkExit = {
    value: 1,
  };
  $scope.notifications = {};
  $scope.entryFilter = {
    status: 'waiting'
  };
  $scope.bulkMode = {
    enabled: false,
    selectedEntries: {},
    allEntries: false
  };
  $scope.tempInfoModal = {
    entryId: null,
    modal: null
  };

  $scope.getEntries = () => {
    return filter($scope.entries, $scope.entryFilter);
  }

  $scope.showNextButton = () => {
    if($scope.isBulkMode()){
      return;
    }
    const status = get($scope.entryFilter, 'status', null);
    return status === 'waiting';
  }

  $scope.getWaitingEntries = () => {
    return filter($scope.entries, (entry) => entry.status === 'waiting');
  };

  $scope.getCanceledEntries = () => {
    return filter($scope.entries, (entry) => entry.status === 'canceled');
  };

  $scope.getConfirmedEntries = () => {
    return filter($scope.entries, (entry) => entry.status === 'waiting' && !!entry.checkedInTime);
  };

  $scope.filterByStatusWaiting = () => {
    $scope.entryFilter.status = 'waiting';
  };

  $scope.filterByStatusCanceled = () => {

    if(!$scope.getCanceledEntries().length){
      return;
    }

    $scope.entryFilter.status = 'canceled';
  };

  $scope.isWaiting = () => {
    return $scope.entryFilter.status === 'waiting'
  };

  $scope.isCanceled = () => {
    return $scope.entryFilter.status === 'canceled'
  };

  const place = PlaceService.GetCurrent();

  const setStats = ({
    capacity,
    total,
    totalPeopleWaiting,
    totalPhysical,
    requiresConfirmation,
    enterWithoutConfirmation,
    supportDelay
  }) => {
    $timeout(() => {
      $scope.capacity = capacity;
      $scope.total = total;
      $scope.totalPeopleWaiting = totalPeopleWaiting;
      $scope.totalPhysical = totalPhysical;
      $scope.requiresConfirmation = requiresConfirmation;
      $scope.enterWithoutConfirmation = enterWithoutConfirmation;
      $scope.supportDelay = supportDelay;
      verifySelectedEntry();
    });
  };

  const setLinkAndQr = (data) => {
    $timeout(() => {
      $scope.agendaLink = data.agendaUrl;
      $scope.qr = data.qrCode;
    });
  }

  const setEntries = (entries) => {
    $scope.entries = Object.values(entries);
  }

  const setMessage = (messages) => {
    const itIsYourTurn = find(messages, (msg) => msg.slug === 'its_your_turn');
    const config = get(itIsYourTurn, 'configuration');
    const sms = find(config, (item) => item.type === 'sms');
    const enabled = get(sms, 'enabled', false);
    $scope.sendMessages = enabled;
  }

  const availableEntries = ()  => $scope.capacity - $scope.total;
  PlaceService.GetLinkAndQr(place._id).then(setLinkAndQr);
  PlaceService.GetStats(place._id).then(setStats);
  CapacityService.GetEntries().then(setEntries);
  OrganizationMessagesService.GetAllReadAsPromise(place.organizationId, place._id).then(setMessage);

  $scope.disabledNextButton = () => {

    const waitingEntries = $scope.getWaitingEntries();

    return !waitingEntries.length || 
           !$scope.selectedEntry || 
           !$scope.selectedEntry._id || 
           availableEntries() <  $scope.selectedEntry.people;
  }

  $scope.disabledPhysicalEntriesButton = () => {
    return availableEntries() < 1;
  }

  $scope.chatEnabled = () => {
    return get(place, 'capacityControl.configuration.supportTwoWaysSMS', false);
  }

  $scope.openChatModal = (entry) => {
    entry.showNewNotificationAlert = false;
    CapacityService.GetNotificationsBySubscriptionId(entry._id).then(response => {
      $scope.notifications[entry._id] = response;
      $scope.openChat(entry, $scope.notifications[entry._id]);
    });
    
  }

  $scope.openChat = (entry, notifications) => {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/capacity/chat.html',
      size: 'sm',
      controller: 'ChatController',
      resolve: {
        entry: () => entry,
        notifications: () => notifications,
      }
    });
  }

  $scope.showAlert = (entry) => {
    return get(entry, 'showNewNotificationAlert', false);
  }

  $scope.addPhysicalEntries = () => {
    const modalInstance = $uibModal.open({
      templateUrl: '/templates/components/modals/capacity/add-physical-entries.html',
      size: 'md',
      controller: 'AddPhisicalEntriesController',
      resolve: {
        max: () => availableEntries()
      }
    });

    modalInstance.result
      .then((entries) => {
        if(!entries){
          return;
        }
        CapacityService.AddPhysicalEntries(entries)
        .then(() => {
          NotificationService.Success($translate.instant('success'));
        })
        .catch(() => {
          NotificationService.Error($translate.instant('ups_some_wrong'));
        })
      })
  }

  $scope.disabledEntryButton = (entry) => {

    const waitingEntries = $scope.getWaitingEntries();

    return !waitingEntries.length || 
           ($scope.requiresConfirmation && !$scope.enterWithoutConfirmation && !entry.checkedInTime) || 
           !entry || 
           !entry._id || 
           availableEntries() <  entry.people;
  }

  $scope.entranceNext = () => {
    if (!$scope.selectedEntry._id) return;
    CapacityService.Entrance($scope.selectedEntry._id)
  }

  $scope.entrance = (entry) => {
    if (!entry || !entry._id) return;
    if ($scope.disabledEntryButton(entry)) return;
    CapacityService.Entrance(entry._id)
  }

  $scope.disabledExitButton = () => {

    const value = parseInt($scope.bulkExit.value) || 0;

    return $scope.total === 0 ||
      value > $scope.total ||
      value < 1
    ;
  }

  $scope.exit = () => {
    if (!$scope.bulkExit) {
      return;
    }
    CapacityService.Exit($scope.bulkExit.value).then(() => {
        $scope.bulkExit.value = 1;
      })
      .catch(() => {
        NotificationService.Error($translate.instant('ups_some_wrong'));
      })
  }

  $scope.cancelEntry = (entry) => {

    if(!entry || !entry._id){
      return;
    }

    dialog.confirm($translate.instant('subscription_cancel_confirm'))
      .then(() => {
        CapacityService.Cancel(entry._id).then(data => {
          updateEntry(data);
        })
      })
      .catch(() => {})
  }

  $scope.sendNotification = (entry) => {

    if(!entry || !entry._id){
      return;
    }

    dialog.confirm($translate.instant('send_entry_notification?'))
      .then(() => {
        CapacityService.SendNotification([entry._id])
        .then(() => {
          NotificationService.Success($translate.instant('notification_has_been_sent'));
        })
        .catch(() => {
          NotificationService.Error($translate.instant('ups_some_wrong'));
        })
      })
      .catch(() => {})
  }

  $scope.isConfirmed = (entry) => {

    if(!entry){
      return false;
    }

    if(!$scope.requiresConfirmation){
      return false;
    }

    return !!entry.checkedInTime
  }

  $scope.lateEntry = (entry) => {

    if(!entry){
      return false;
    }

    if(!$scope.supportDelay){
      return false;
    }

    return !!entry.delayTime
  }

  $scope.info = (entry) => {
    const modal = $uibModal.open({
      templateUrl: '/templates/components/modals/capacity/entry-info.html',
      size: 'sm',
      controller: 'EntryInfoController',
      resolve: {
        entry: () => entry,
        modalInfoFromServer: () => CapacityService.GetModalInfoFromServer(entry._id),
      },
    });

    setTempInfoModal(entry._id, modal);
  };

  $scope.isBulkMode = () => {
    return get($scope.bulkMode, 'enabled', false);
  }

  $scope.clickEntry = (entry) => {
    if(!$scope.isBulkMode()){
      return;
    }

    const value = get($scope.bulkMode, `selectedEntries.${entry._id}`, false);

    set($scope.bulkMode, `selectedEntries.${entry._id}`, !value);

  }

  $scope.disabledBulkSms = () => {
    const result = getBulkSelectedEntries();
    return !result.length;
  }

  $scope.onChangeBulkMode = () => {
    set($scope.bulkMode, 'selectedEntries', {});
  }

  $scope.onChangeAllEntries = () => {
    const waitingEntries = $scope.getWaitingEntries();
    const value = get($scope.bulkMode, 'allEntries', false);
    for(const entry of waitingEntries){
      set($scope.bulkMode, `selectedEntries.${entry._id}`, value)
    }
  }

  $scope.onChangeSelectedEntries = () => {
    $timeout(() => {
      const selectedEntriesLength = getBulkSelectedEntries().length;
    
      const waitingEntriesLength = $scope.getWaitingEntries().length;
  
      const result = selectedEntriesLength === waitingEntriesLength;
  
      set($scope.bulkMode, 'allEntries', result);
    })

  }

  $scope.mobileCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  $scope.bulkSms = () => {

    const result = getBulkSelectedEntries();

    if(!result.length){
      return;
    }
    const notifications = get(place, 'capacityControl.configuration.defaultMessages', []);
    $scope.openChat(result, notifications);
    
  }

  $scope.toggleBulkMode = () => {
    $scope.bulkMode.enabled = !$scope.bulkMode.enabled;
    $scope.bulkMode.allEntries = false;
  }

  const bulkModeOff = () => {
    $scope.bulkMode.enabled = false;
    $scope.bulkMode.selectedEntries = {};
  }

  /* Private methods */

  const verifySelectedEntry = () => {

    const waitingEntries = $scope.getWaitingEntries();

    if(!waitingEntries.length){
      $scope.selectedEntry = {};
      return;
    }

    if(!$scope.requiresConfirmation || 
       ($scope.requiresConfirmation && $scope.enterWithoutConfirmation)) {
      if(!$scope.selectedEntry._id){
        $scope.selectedEntry = waitingEntries[0];
        return;
      }
  
      const entryResult = waitingEntries.find(entry => {
        return entry._id === $scope.selectedEntry._id
      });
  
      if(!entryResult){
        $scope.selectedEntry = waitingEntries[0];
        return;
      }
    } else {
      const sortedConfirmedEntries = sortBy($scope.getConfirmedEntries(), ['checkedInTime']);
      const entryResult = head(sortedConfirmedEntries);

      if(!entryResult){
        $scope.selectedEntry = {};
        return;
      }

      $scope.selectedEntry = entryResult;
    }

  }

  const updateEntry = (updatedEntry) => {
    $timeout(() => {
      for(let i = 0; i < $scope.entries.length; i++){
        if($scope.entries[i]._id === updatedEntry._id){
          $scope.entries[i] = updatedEntry;
          break;
        }
      }
      verifySelectedEntry();
      verifyCloseInfoModal(updatedEntry);
    })
  }

  const createEntry = (newEntry) => {
    $timeout(() => {
      $scope.entries.push(newEntry)
      $scope.entries = $scope.entries.sort((a, b) => b.date - a.date);
      verifySelectedEntry();
    })
  }

  const getBulkSelectedEntries = () => {
    const result = [];
    for (const [key, value] of Object.entries($scope.bulkMode.selectedEntries)) {
      if(!value){
        continue;
      }
      result.push(key);
    }
    return result;
  }

  const setTempInfoModal = (entryId, modal) => {
    $scope.tempInfoModal = { entryId, modal};
  }

  const verifyCloseInfoModal = (entry) => {
    if(
      entry._id === $scope.tempInfoModal.entryId &&
      entry.status === 'canceled'
      ){
      $scope.tempInfoModal.modal.close();
    }
  }

  /* Events ON */

  $rootScope.$on('entry:updated', (event, data) => {
    updateEntry(data);
  });

  $rootScope.$on('notifications:updated', (event, data) => {
    const subscriptionId = data[0].subscription.id;
    $scope.notifications[subscriptionId] = data;
    const entry = $scope.entries.find(ent => ent._id === subscriptionId);
    $timeout(() => {
      $scope.entries[$scope.entries.indexOf(entry)].showNewNotificationAlert = true;
    });
  });

  $rootScope.$on('entry:created', (event, data) => {
    createEntry(data);
  });

  $rootScope.$on('place:stats-changed', (e, s) => setStats(s));

  $rootScope.$on('place:capacity-changed', (event, { capacity }) => {
    $timeout(() => {
      $scope.capacity = $scope.totalCapacity = capacity;
    })
  });

};

module.exports = module.controller('CapacityControlController', CapacityControlController);
